import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Container, Row } from "reactstrap";
import { Col } from "react-bootstrap";
import { Breadcrumbs } from "../../AbstractElements";
import SampleCollectionHome from "./SampleCollectionHome";

export default function SampleCollectionList() {
    const { t } = useTranslation();
    return (
        <Fragment>
            <Breadcrumbs
                mainTitle={t("Sample Collection")}
                parent={t("Home")}
                title={t("Sample Collection")}
            />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                        <SampleCollectionHome />
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
}
